import { get } from 'lodash';
import { REMOVE_PAYMENT, UPDATE_STOP_PAYMENT_OPTION, UPDATE_TYPE, INIT_PAYMENTS } from '../payments/actions';
import { INIT_VALIDATION, INIT_VALIDATION_FOR_TEMPLATE } from './actions';
import { RESET_APP } from '../page/actions';
import { initialState } from './common';

const initState = { ...initialState };
export const defaultTemplateItem = {
	toAccount: initState,
	reference: initState,
};
export const defaultItem = {
	toAccount: initState,
	date: initState,
	amount: initState,
	reference: initState,
};

export const FPHandlers = {
	[INIT_VALIDATION]: (state, action) => {
		if (action.templateMode) {
			return {
				...state,
				[action.id]: { ...defaultTemplateItem },
			};
		}
		return { ...state, [action.id]: { ...defaultItem } };
	},
	[INIT_VALIDATION_FOR_TEMPLATE]: (state) => ({
		...state,
		'template-name': { name: { ...initialState, isValid: true } },
	}),
	[INIT_PAYMENTS]: (state) => ({ paymentType: state.paymentType }),
	[RESET_APP]: (state) => ({ paymentType: state.paymentType }),
	[REMOVE_PAYMENT]: (state, action) => {
		const { [action.id]: keyToDelete, ...newState } = state;
		return newState;
	},
	[UPDATE_STOP_PAYMENT_OPTION]: (state, action) => {
		if (action.stopPaymentOption === 'on-number') {
			return {
				...state,
				[action.id]: {
					...state[action.id],
					stopPaymentOnNumber: { ...initialState },
				},
			};
		}
		const { stopPaymentOnNumber, ...newBlock } = get(state, `${action.id}`, {});
		return { ...state, [action.id]: newBlock };
	},
	[UPDATE_TYPE]: (state, action) => {
		if (action.paymentType === 'repeating') {
			const { stopPaymentOnNumber, ...newBlock } = get(state, `${action.id}`, {});
			return {
				...state,
				[action.id]: {
					...newBlock,
					frequency: { ...initialState },
				},
			};
		}
		const { stopPaymentOnNumber, frequency, ...newBlock } = get(state, `${action.id}`, {});
		return { ...state, [action.id]: newBlock };
	},
};
